import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Timestamp } from "firebase/firestore";
import { Modal, Button } from "react-bootstrap";
import { FaPlusCircle } from "react-icons/fa";
import Gig from "./Gig";
import { addNewGig } from "../Config/firebase";

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

export type AddGigProps = {
  onSave?: (title: String, date: Date, imagePath: string) => void;
};

export function AddGigModal(props: AddGigProps) {
  const [showModal, setShowModal] = useState<boolean>(false);

  const [title, setTitle] = useState<string>("Event Name");
  const [date, setDate] = useState<Date>(new Date());

  const [imageFile, setImageFile] = useState<File | null>(null);
  const [image, setImage] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);

  function openModal() {
    setShowModal(true);
  }
  function closeModal() {
    setShowModal(false);
  }
  function saveEvent() {
    // TODO validate input, before saving
    if(imageFile === null) {
      closeModal(); //TODO would be better to just deny saving
    }

    // show loading spinner while saving
    setLoading(true);


    // Add Gig to Firebase
    addNewGig(title, date, image, imageFile!);

    // Notify Gig was added
    if (props.onSave) {
      props.onSave(title, date, image);
    }

    // Reset the form
    setTitle("Event Name");
    setDate(new Date());
    setImage("");
    setImageFile(null);

    setLoading(false);

    closeModal();
  }

  // Helper function to convert Date to string
  function dateToString(date: Date): string { 
    if (isNaN(date.getTime())) {
      // Handle the error or return a default/fallback value
      return "-";
    }
    return date.toISOString().split("T")[0];
  }

  // Helper function to convert string to Date
  function stringToDate(dateString: string): Date {
    return new Date(dateString);
  }

  function handleImageChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files ? e.target.files[0] : null;
    if (file) {
      setImage(URL.createObjectURL(file));
      setImageFile(file); // Store original file name
    }
  }

  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div>
      <button
        onClick={openModal}
        className="btn btn-dark"
        style={{ backgroundColor: "transparent", borderColor: "transparent" }}
      >
        <FaPlusCircle size={20} />
      </button>
      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Event</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!loading ? (
            <Form>
              <InputGroup className="d-flex justify-content-between align-items-center">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Event Title</Form.Label>
                  <Form.Control
                    placeholder={title}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Event Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    placeholder="DateRange"
                    value={dateToString(date)}
                    onChange={(e) => setDate(stringToDate(e.target.value))}
                  />
                </Form.Group>
              </InputGroup>
              <InputGroup className="d-flex justify-content-between align-items-center">
                <Form.Group className="mb-3" controlId="formEventImage">
                  <Button onClick={handleClick} className="btn btn-primary">
                    Select Image
                  </Button>
                  <Form.Control
                    type="file"
                    ref={fileInputRef}
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />
                </Form.Group>
              </InputGroup>
            </Form>
          ) : null}

          <Gig
            id={""}
            title={title}
            date={Timestamp.fromDate(date)}
            imageURL={image}
            canEdit={false}
          />
        </Modal.Body>
        <Modal.Footer>
          {!loading ? (
          <Button onClick={saveEvent}>Save</Button>
        ) : (
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}
